import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

interface IProps {
  isVisible: boolean;
  isCorrect: boolean;
}

export const AnswerStatus = React.memo(({ isVisible, isCorrect }: IProps) => {
  const t = useTranslations();
  
  if (!isVisible) return null;

  return (
    <div className="flex items-center gap-1 text-xs">
      {isCorrect ? (
        <>
          <div className="w-18 relative -right-5 -top-2 h-9">
            <Image
              fill
              unoptimized
              src="/images/correct-answer.gif"
              alt={t('togri_javob')}
              className="-right-100 absolute"
            />
          </div>
          {t('togri_javob')}
        </>
      ) : (
        <>
          <Image width={20} height={20} unoptimized src="/images/incorrect-answer.gif" alt={t('notogri_javob')} />
          {t('notogri_javob')}
        </>
      )}
    </div>
  );
});
